import { render, staticRenderFns } from "./UserHistory.vue?vue&type=template&id=4c9ac5d4&scoped=true&"
import script from "./UserHistory.vue?vue&type=script&lang=js&"
export * from "./UserHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserHistory.vue?vue&type=style&index=0&id=4c9ac5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9ac5d4",
  null
  
)

export default component.exports